import { LOADING_REFERENCES_CONTEXT, RECEIVED_REFERENCES_CONTEXT, RECEIVED_REFERENCES_CONTEXT_FAILED } from '../../actions/types';
import { createFetcherReducer } from '../utils';

export default createFetcherReducer(
  LOADING_REFERENCES_CONTEXT,
  RECEIVED_REFERENCES_CONTEXT,
  RECEIVED_REFERENCES_CONTEXT_FAILED,
);
